
const status = state => state.status
const distributionDates = state => state.distributionDates
const typeValues = state => state.typeValues
const distributions = state => state.distributions
const distributionIds = state => state.distributions.map(item => item.distributionId)

export default {
    status,
    distributionDates,
    typeValues,
    distributions,
    distributionIds
}
